import { ClampContainerMixin } from 'common/components/Typography';
import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
const { font_color_c, font_color_d, font_color_e } = variables;

GlobalStyle.inject`
  .metadata-major-category {
    font-size: ${getScalablePixel(20)}px;
    color: ${font_color_e};
    text-transform: uppercase;
  }
  .metadata-minor-categories {
    ${ClampContainerMixin({})}
    font-weight: normal;
    text-transform: uppercase;
    color: ${font_color_c};
    opacity: 0.8;
    word-break: break-all;
  }

  .metadata-rating {
    display: flex;
    align-items: center;
    *:not(:last-child) {
      margin-right: ${getScalablePixel(4)}px;
    }
  }
  .metadata-rating-max {
    color: ${font_color_d};
    font-weight: normal;
  }
`;
